import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

import { Error } from '@src/components/utils';

const component = () => <Outlet />;
const errorComponent = () => <Error />;
const notFoundComponent = () => {
  return (
    <div>
      <p>This is the notFoundComponent configured on root route</p>
    </div>
  );
};

const options = {
  component,
  notFoundComponent,
};

if (import.meta.env.MODE === 'production') {
  options.errorComponent = errorComponent;
}

export const Route = createRootRouteWithContext()(options);
